module.exports = __webpack_public_path__ + "img/carpet_three.36dc046a.png";